import { initializeApp } from "firebase/app";
import { getAuth, sendPasswordResetEmail, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// Config using environment variables
const firebaseConfig = {
    apiKey: "AIzaSyBnG0AgF1sikxssidtBSQ8ZgDmfYVhaP0c",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID  // Optional
};
  

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Get database name from environment or use default
const databaseName = process.env.REACT_APP_FIRESTORE_DATABASE_NAME;

// Log the database being used
console.log('🗄️ Firebase Database Configuration:');
console.log(`📊 Database Name: ${databaseName || 'default (main)'}`);
console.log(`🌐 Environment: ${databaseName === 'uatrs' ? 'Development (UAT)' : 'Production'}`);

// Initialize Firestore with specific database or default
const db = databaseName ? getFirestore(app, databaseName) : getFirestore(app);
const functions = getFunctions(app);

// Connect to emulators if running on localhost
// const isLocalhost = window.location.hostname === 'localhost' || 
//                    window.location.hostname === '127.0.0.1' ||
//                    window.location.hostname === '[::1]';

// if (isLocalhost || process.env.REACT_APP_USE_EMULATORS === 'true') {
//   try {
//     // Connect to Auth emulator
//     connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
//     console.log('🔗 Connected to Firebase Auth Emulator');
    
//     // Connect to Firestore emulator
//     connectFirestoreEmulator(db, "localhost", 8080);
//     console.log('🔗 Connected to Firebase Firestore Emulator');
//     console.log(`📊 Using database: ${databaseName}`);
    
//     // Connect to Functions emulator
//     connectFunctionsEmulator(functions, "localhost", 5001);
//     console.log('🔗 Connected to Firebase Functions Emulator');
    
//   } catch (error) {
//     console.warn('⚠️ Emulator connection failed:', error.message);
//     console.log('💡 Make sure Firebase emulators are running with: firebase emulators:start');
//   }
// } else {
//   console.log('🌐 Using production Firebase services');
//   console.log(`📊 Using database: ${databaseName}`);
// }

export { auth, db, functions, sendPasswordResetEmail };